export default function formatPhoneNumber(originalString: string) {
  return `${originalString.substring(0, 3)}-${originalString.substring(
    3,
    6
  )}-${originalString.substring(6, 10)}`;
}
